<template>
    <div class="Login">
        <el-button type="text" icon="el-icon-close" @click="$emit('close')" id="close"></el-button>

        <h4>{{'Please Login To Continue' | language}}</h4>
        <el-alert v-if="error" title="Incorrect email address and / or password." type="error"
            description="These credentials do not match our records." show-icon>
        </el-alert>

        <el-form :model="loginForm" status-icon ref="loginForm" label-width="120px" class="demo-ruleForm" :rules="$store.state.general.language === 'english' ? rules : rulesJp"
            @submit.native.prevent
            :label-position="labelPosition">
            <el-form-item prop="email">
                <el-input v-model="loginForm.email" autocomplete="off" @keyup.enter.native="submitForm('loginForm')" placeholder="Email Address" prefix-icon="el-icon-message"></el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password" v-model="loginForm.password" autocomplete="off" @keyup.enter.native="submitForm('loginForm')" placeholder="Password" prefix-icon="el-icon-lock"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="Login__Button" type="primary" @click="submitForm('loginForm')" :loading="loading">{{'Login' | language}}</el-button>
            </el-form-item>
            <el-form-item>
                <router-link to="/register" class="navigation navigation__navitem">{{'Create an account' | language}}</router-link>
                <router-link to="/forgotten-password" class="navigation navigation__navitem forgot-password">{{'Forgot Password' | language}}
                </router-link>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: 'login-modal',
        components: {
        },
        props: {},
        watch: {
            '$route.params': function() {
                this.$emit('close')
            }
        },
        data: function () {
            return {
                labelPosition: 'top',
                loginForm: {
                    email: '',
                    password: '',
                },
                error: false,
                loading: false,
                rules: {
                    email: [
                        { required: true, message: 'Please input email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                    ],
                    password: [
                        { message: 'password is required', required: true}
                    ]
                },
                rulesJp: {
                    email: [
                        { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
                        { type: 'email', message: '正しいメールアドレスを入力してください', trigger: ['blur', 'change'] }
                    ],
                    password: [
                        { message: 'パスワードが必要です', required: true}
                    ]
                }
            }
        },

        created() {
        },

        methods: {
            submitForm(formName) {
                event.preventDefault()

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.error = false
                        this.loading = true
                        const params = {
                        email: this.loginForm.email,
                        password: this.loginForm.password
                    }
                    const promise = this.$store.dispatch('user/login', params);
                    promise
                        .then(() => {
                            this.$emit('close')
                        })
                        .catch(() => {
                            this.error = true;
                        })
                        .finally(() => {
                            this.loading = false
                        })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .Login {
        padding: 1em 2em;

        #close {
            position: absolute;
            top: 1em;
            right: 1em;
            padding: 0;
        }

        form {
            width: 100%;
            margin: 0 auto;

            .el-form-item {
                margin-top: 1em!important;

                &.is-error {
                    margin-bottom: 1.5em!important;
                }
            }

            .bottom-links {
                margin-top: .5em!important;
            }

            .navigation__navitem {
                padding: 0;
                color: $alternate-color;

                &.forgot-password {
                    float: right;
                }
            }
        }

        h4 {
            text-align: center;
        }

        &__Button {
            width: 100%;
        }
    }
</style>